import * as React from 'react';

import { mosaiqStyled } from '../../lib';
import { Wrapper } from './Container.styles';
import { ContainerProps } from './types';

const Container = mosaiqStyled<ContainerProps>(
  ({ position, top, bottom, left, right, fullWidth, maxWidth, children, ...props }) => {
    return (
      <Wrapper
        {...props}
        position={position}
        top={top}
        bottom={bottom}
        left={left}
        right={right}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        {children}
      </Wrapper>
    );
  },
);

Container.displayName = 'Container';

export default Container;
